<template>
  <div class="entrance">
    <div class="cont">
      <div class="head-cont">
        <img class="head-pic" src="../assets/mian.jpg" alt />
       
      </div>
      <div class="cont-msg">
        <el-card alaways>
          <el-row type="flex" align="middle">
            <el-col :span="8">
              <strong style="color:#FF4887;">顺序练习</strong>
            </el-col>
            <el-col :span="7">
              <span></span>
            </el-col>
            <el-col :span="9" class="text-right">
              <el-button round type="error" size="medium" @click="link('paperTable')">开始答题</el-button>
            </el-col>
          </el-row>
        </el-card>
        <el-card alaways>
          <el-row type="flex" align="middle">
            <el-col :span="8">
              <strong style="color:#2625C3;">模拟考试</strong>
            </el-col>
            <el-col :span="7">
              <span>100%真题</span>
            </el-col>
            <el-col :span="9" class="text-right">
              <el-button round type="primary" size="medium" @click="link('personalPaper')">开始考试</el-button>
            </el-col>
          </el-row>
        </el-card>
        <el-card alaways>
          <el-row>
            <el-col :span="12" class="text-center">
              <div class="el-icon-edit exam-icon"></div>
              <p>
                <a @click="link('practice',id)">错题练习</a>
              </p>
            </el-col>
            <el-col :span="12" class="text-center">
              <div class="el-icon-reading exam-icon"></div>
              <p>
                <a href>考前须知</a>
              </p>
            </el-col>
          </el-row>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "entrance",
  data() {
    return {
      res: {
        num: 10086
      },
      id:null
    };
  },
  created() {
    this.init();
  },
  methods: {
    init(){
      this.id= this.$route.params.id;
    },
    link(name,id){
      if(id){
        this.$router.push({name:name,params:{id:id}})
      }else{
        this.$router.push({name:name})
      }
    }
  }
};
</script>
<style lang="less"  scope>
a {
  text-decoration: none;
  color: #333;
}
.entrance {
  width: 100%;
  max-width:1000px;
  margin:0 auto;
  background: #ecf2fe;
  min-height: 100%;
  .cont {
    .head-cont {
      position: relative;
      .exam-name {
        position: absolute;
        top: 20%;
        left: 20px;
        color: #fff;
      }
      img {
        width: 100%;
      }
    }

    .cont-msg {
      position: relative;
      text-align: center;
      font-size: 16px;
      color: #3a3a3a;
      margin: -40px 15px 0;
      padding: 20px 0;
      .el-card {
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .el-card__body {
          width: 100%;
        }
        span {
          margin: 0 10px;
          font-size: 14px;
        }
        strong {
          font-size: 20px;
        }
        .text-right {
          text-align: right;
        }
        .el-button--error {
          background: #ff4887;
          border-color: #ff4887;
          color: #fff;
          font-weight: bolder;
          padding: 10px;
        }
        .el-button--primary {
          background: #2625c3;
          border-color: #2625c3;
          font-weight: bolder;
          padding: 10px;
        }
        .exam-icon {
          font-size: 30px;
          color: #333;
        }
      }
      .cont-title {
        font-size: 22px;
        margin: 0;
        color: #000;
      }
      p {
        margin: 0;
        padding: 14px 0;
      }
    }
  }
}
</style>
